<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <CompleteRegis />
    <LoginShow />
  </div>
</template>

<script>
import CompleteRegis from "@/components/CompleteRegis/index.vue";
import LoginShow from "@/components/loginShow/index.vue";

export default {
  name: 'App',
  components: { CompleteRegis,LoginShow },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },

  watch: {
    '$i18n.locale' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.reload()
      }
    }
  },
  created(){},
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
